export { ReactComponent as TextHighlight } from './svgs/text-highlight.svg';
